import { CheckboxFilterItem } from '@components/cockpit/panels/CheckboxListFilter';
import { SearchFilterOptionEnum } from '@components/cockpit/panels/notificationSearch/notificationSearch.types';
import { availableFilterOptionsByCategory } from '@components/cockpit/panels/notificationSearch/useDisplaySearchFilterOptions';

import { NotificationFamilyEnum } from '@/types/data/data.types';

const MANDATORY_FILTERS: Set<SearchFilterOptionEnum> = new Set([
  SearchFilterOptionEnum.DETECTION_PERIOD,
  SearchFilterOptionEnum.INCIDENT_PERIOD,
]);

const SearchFilterOptionToLabel: Record<SearchFilterOptionEnum, string> = {
  [SearchFilterOptionEnum.COLLABORATIVE_ID]: 'components.notificationSearch.filters.filterOptions.collaborative',
  [SearchFilterOptionEnum.ID]: 'components.notificationSearch.filters.filterOptions.id',
  [SearchFilterOptionEnum.PLATFORM]: 'components.notificationSearch.filters.platforms',
  [SearchFilterOptionEnum.WORST_CLASSIFICATION]: 'components.notificationSearch.filters.worstClassification',
  [SearchFilterOptionEnum.WORST_SENSOR_STATUS]: 'components.notificationSearch.filters.filterOptions.worstSensorStatus',
  [SearchFilterOptionEnum.DETECTION_PERIOD]: 'components.notificationSearch.filters.filterOptions.detectionPeriod',
  [SearchFilterOptionEnum.INCIDENT_PERIOD]: 'components.notificationSearch.filters.filterOptions.incidentPeriod',
  [SearchFilterOptionEnum.MAX_ALTITUDE_OR_HEIGHT]:
    'components.notificationSearch.filters.filterOptions.maxAltitudeOrHeight',
  [SearchFilterOptionEnum.RELIABILITY]: 'components.notificationSearch.filters.filterOptions.reliability',
  [SearchFilterOptionEnum.DETECTION_DURATION]: 'components.notificationSearch.filters.filterOptions.detectionDuration',
  [SearchFilterOptionEnum.TREATMENT_DURATION]: 'components.notificationSearch.filters.filterOptions.treatmentDuration',
  [SearchFilterOptionEnum.TRACK_SENSOR]: 'components.notificationSearch.filters.sensors.title',
  [SearchFilterOptionEnum.ZONES]: 'components.notificationSearch.filters.filterOptions.zones.label',
};

const SearchFilterOptionToComment: Partial<Record<SearchFilterOptionEnum, string>> = {
  [SearchFilterOptionEnum.ZONES]: 'components.notificationSearch.filters.filterOptions.zones.comment',
};

export function getSearchCheckboxItems(
  category: NotificationFamilyEnum,
  isChecked: (option: SearchFilterOptionEnum) => boolean,
  onChange: (option: SearchFilterOptionEnum) => void,
  canAccessNFZ: boolean,
): CheckboxFilterItem[] {
  const availableOptions = Array.from(availableFilterOptionsByCategory[category].values()).filter(
    (option) => option !== SearchFilterOptionEnum.ZONES || canAccessNFZ,
  );

  return availableOptions.map((option) => ({
    label: SearchFilterOptionToLabel[option],
    checked: isChecked(option),
    readOnly: MANDATORY_FILTERS.has(option),
    comment: SearchFilterOptionToComment[option],
    ...(!MANDATORY_FILTERS.has(option) && { onChange: () => onChange(option) }),
  }));
}
